import { Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as CloneForm } from './clone_form'

interface Props {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  eventId: string
}

export const CloneDialog = ({ open, setOpen, eventId }: Props) => {
  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>Clone event</DialogTitle>
        <DialogBody>
          <CloneForm eventId={eventId} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
